import endOfDay from 'date-fns/endOfDay';
import startOfDay from 'date-fns/startOfDay';

import { formatDateIso } from '../../dateTime';
import { queryKeys } from '../queryKeys';

import { fetchChannelPrograms } from './fetchChannelPrograms';

export function createChannelProgramsQueryOptions(channelId: number, day: string) {
  const date = new Date(day);

  return {
    queryKey: queryKeys.channelPrograms(channelId, formatDateIso(date)),
    queryFn: () =>
      fetchChannelPrograms({
        startDate: startOfDay(date).getTime(),
        endDate: endOfDay(date).getTime(),
        channelId,
      }),
  };
}
